<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ManufacturerForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ManufacturerForm from '@/components/settings/stock-registers/manufacturer/ManufacturerForm'

export default {
  name: 'Manufacturers',
  components: {
    PageTitle,
    PageRowWrapper,
    ManufacturerForm
  }
}
</script>
